export default {"src":"/_next/static/media/calculator_40.5532b7fe.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};